/**
 * Calcule la distance de Levenshtein entre deux chaînes
 */
export const levenshteinDistance = (str1: string, str2: string): number => {
  const track = Array(str2.length + 1)
    .fill(null)
    .map(() => Array(str1.length + 1).fill(null))

  for (let i = 0; i <= str1.length; i += 1) {
    track[0][i] = i
  }

  for (let j = 0; j <= str2.length; j += 1) {
    track[j][0] = j
  }

  for (let j = 1; j <= str2.length; j += 1) {
    for (let i = 1; i <= str1.length; i += 1) {
      const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1
      track[j][i] = Math.min(track[j][i - 1] + 1, track[j - 1][i] + 1, track[j - 1][i - 1] + indicator)
    }
  }

  return track[str2.length][str1.length]
}

/**
 * Vérifie si un domaine d'email pourrait être une faute de frappe de gmail.com ou hotmail.com
 */
export const checkGmailTypo = (
  email: string,
): {
  hasTypo: boolean
  suggestedEmail?: string
} => {
  if (!email || !email.includes('@')) {
    return { hasTypo: false }
  }

  const [localPart, domain] = email.split('@')

  const knownDomains = ['gmail.com', 'hotmail.com']
  const suggestionMap: Record<string, string> = {
    gmail: 'gmail.com',
    hotmail: 'hotmail.com',
  }

  if (knownDomains.includes(domain)) {
    return { hasTypo: false }
  }

  const candidates = Object.keys(suggestionMap)
  let bestCandidate = ''
  let bestDistance = Infinity

  for (const candidate of candidates) {
    const distance = levenshteinDistance(domain, suggestionMap[candidate])
    if (distance < bestDistance) {
      bestDistance = distance
      bestCandidate = candidate
    }
  }

  if (bestDistance <= 2) {
    return {
      hasTypo: true,
      suggestedEmail: `${localPart}@${suggestionMap[bestCandidate]}`,
    }
  }

  return { hasTypo: false }
}
